(() => {
  'use strict';

  const browserWindow = typeof window !== 'undefined' ? window : null;
  if (browserWindow?.TISPersonalizationSurchargeInitialized) return;
  if (browserWindow) browserWindow.TISPersonalizationSurchargeInitialized = true;

  const incrementSelector = '[data-personalization-increment-ends-at]';

  const hideIncrement = (element) => {
    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
    element.dataset.personalizationSurchargeState = 'expired';
  };

  const updateIncrement = (element, now = Date.now()) => {
    if (!element) return;
    const endsAt = element.dataset.personalizationIncrementEndsAt;
    if (!endsAt) return;
    const endsTime = Date.parse(endsAt);
    if (!Number.isFinite(endsTime) || endsTime <= now) {
      hideIncrement(element);
      return;
    }
    element.hidden = false;
    element.removeAttribute('aria-hidden');
    element.dataset.personalizationSurchargeState = 'current';
  };

  const updateAll = () => {
    document.querySelectorAll(incrementSelector).forEach((element) => updateIncrement(element));
  };

  if (browserWindow?.document) {
    updateAll();
    browserWindow.setInterval(updateAll, 1000);
    document.addEventListener('shopify:section:load', updateAll);
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { updateIncrement };
})();
